import type { DailySessionResponse } from '@empathybroker/tsclient-stats/dist/models/daily-session/daily-session.response'

import type { AnalyticsState, MutationClass, PeriodsData } from '../../../models'

export class SetSessionsDataMutation implements MutationClass {
  static execute(
    this: void,
    state: AnalyticsState,
    payload: { data: Partial<PeriodsData<DailySessionResponse>> },
  ): void {
    state.data.overall.sessions = Object.assign({}, state.data.overall.sessions, payload.data)
  }
}
